var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.clickoutside),
      expression: "clickoutside"
    }],
    staticStyle: {
      "position": "relative",
      "width": "300px"
    }
  }, [_c('span', {
    class: _vm.rootCls,
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        _vm.setOpenState(!_vm.open)
      }
    }
  }, [_c('span', {
    key: "selection",
    ref: "selection",
    class: (_vm.prefixCls + "-selection " + _vm.prefixCls + "-selection--" + (_vm.multiple ? 'multiple' : 'single'))
  }, [(!_vm.multiple) ? [_c('span', {
    class: (_vm.prefixCls + "-selection__rendered")
  }, [(_vm.value$.length) ? _c('span', {
    key: "value",
    class: (_vm.prefixCls + "-selection-selected-value"),
    attrs: {
      "title": _vm.value$[0].label
    }
  }, [_vm._v(_vm._s(_vm.value$[0].label))]) : _c('span', {
    key: "placeholder",
    class: (_vm.prefixCls + "-selection__placeholder")
  }, [_vm._v(_vm._s(_vm.placeholder))])])] : [_c('ul', {
    class: (_vm.prefixCls + "-selection__rendered")
  }, [_vm._l((_vm.value$), function(singleValue) {
    return _c('li', {
      key: singleValue.value,
      class: (_vm.prefixCls + "-selection__choice"),
      attrs: {
        "title": singleValue.label
      }
    }, [_c('span', {
      class: (_vm.prefixCls + "-selection__choice__remove"),
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.removeSelected(singleValue.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      class: (_vm.prefixCls + "-selection__choice__content")
    }, [_vm._v(_vm._s(singleValue.label))])])
  }), _vm._v(" "), _c('li', {
    key: "__input",
    class: (_vm.prefixCls + "-search " + _vm.prefixCls + "-search--inline")
  }, [_c('span', {
    class: (_vm.prefixCls + "-search__field__wrap")
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "inputRef",
    class: (_vm.prefixCls + "-search__field"),
    style: ({
      width: (_vm.inputRefWidth + "px")
    }),
    attrs: {
      "role": "textbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }, _vm.onInputChange]
    }
  })])])], 2)], _vm._v(" "), (_vm.allowClear && _vm.value$.length && _vm.value$[0].value) ? _c('span', {
    key: "clear",
    class: (_vm.prefixCls + "-selection__clear"),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onClearSelection($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    key: "arrow",
    class: (_vm.prefixCls + "-arrow"),
    staticStyle: {
      "outline": "'none'"
    }
  }, [_c('b')]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.multiple && (_vm.inputValue !== '' || !_vm.value$.length)),
      expression: "multiple && (inputValue!=='' || !value$.length)"
    }],
    class: (_vm.prefixCls + "-search__field__placeholder"),
    on: {
      "click": _vm.onPlaceholderClick
    }
  }, [_vm._v("\n        " + _vm._s(_vm.placeholder) + "\n      ")])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    class: _vm.dropdowmCls,
    staticStyle: {
      "max-height": "200px",
      "overflow": "auto"
    }
  }, [_c('div', [(!_vm.multiple) ? _c('span', {
    class: ((this.prefixCls) + "-dropdown-search")
  }, [_c('span', {
    class: (_vm.prefixCls + "-search__field__wrap")
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "inputRef",
    class: (_vm.prefixCls + "-search__field"),
    attrs: {
      "role": "textbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }, _vm.onInputChange]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.inputValue),
      expression: "!inputValue"
    }],
    class: (_vm.prefixCls + "-search__field__placeholder"),
    on: {
      "click": _vm.onPlaceholderClick
    }
  }, [_vm._v("\n            " + _vm._s(_vm.searchPlaceholder) + "\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.treedata.length) ? _c('tree', {
    attrs: {
      "multiple": _vm.multiple,
      "data": _vm.treedata,
      "defaultSelectedKeys": _vm.defaultSelectedKeys,
      "defaultExpandedKeys": _vm.defaultExpandedKeys
    },
    on: {
      "onSelect": _vm.onSelect
    }
  }) : _c('span', {
    class: (_vm.prefixCls + "-not-found")
  }, [_vm._v("\n        " + _vm._s(_vm.notFoundContent) + "\n      ")])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ccaf43c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree-select/tree-select.vue
// module id = 78
// module chunks = 0